import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["FounderStorySection"] */ "/vercel/path0/src/components/FounderStorySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerInquiryButton"] */ "/vercel/path0/src/components/partner/PartnerInquiryButton.tsx");
